





















import { defineComponent, PropType, computed } from '@vue/composition-api'
import { useVModel } from '@vueuse/core'

interface Group {
  header: string
  key: string
}

interface Item {
  [key: string]: any
}

export default defineComponent({
  name: 'GroupedCombobox',
  props: {
    value: {
      type: [Number, String, Object] as PropType<number | string | Item | null>,
      default: null,
    },
    items: {
      type: Array as PropType<Item[]>,
      required: true,
    },
    groups: {
      type: Array as PropType<Group[]>,
      required: true,
    },
    groupKey: {
      type: String,
      required: true,
    },
    menuProps: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const model = useVModel(props, 'value', emit)

    const customFilter = (item: any, queryText: string) => {
      if (item.divider) return false
      const text = item.name.toLowerCase()
      const query = queryText.toLowerCase()

      return text.indexOf(query) > -1
    }

    const groupedItems = computed(() => {
      return props.groups.reduce((acc, group) => {
        return acc.concat(
          [{ header: group.header, divider: true }],
          props.items.filter(item => item[props.groupKey] === group.key),
        )
      }, [] as any[])
    })

    return {
      model,
      groupedItems,
      customFilter,
    }
  },
})
